import { render, staticRenderFns } from "./hearing-aid.vue?vue&type=template&id=0b8aa8aa&scoped=true&"
import script from "./hearing-aid.vue?vue&type=script&lang=js&"
export * from "./hearing-aid.vue?vue&type=script&lang=js&"
import style0 from "./hearing-aid.vue?vue&type=style&index=0&id=0b8aa8aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8aa8aa",
  null
  
)

export default component.exports